<div class="ngx-heka-table-actions">
  <ngx-heka-change-table-columns-btn [fixedColumns]="fixedColumns"
                                     [possibleColumns]="possibleColumns"
                                     [displayedColumns]="displayedColumns"
                                     btnTooltip="{{'GENERAL.TABLE.TOOLTIP.ADD_COLUMNS'|translate}}"
                                     overlayTitle="{{'GENERAL.TABLE.COLUMNS'|translate}}"
                                     [columnTranslationMap]="columnTranslationMap">
  </ngx-heka-change-table-columns-btn>
</div>
